import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { ANNUAL_BILLING_TERMS, formatPrice, getPlanPrice } from "../../planPricing";
import { getRegisteringPlan, isBilledYearly } from "../../registrationSession";
import { isEnterprisePacket } from "../../../../../components/Billing/enterprise";

// Enterprise has no price or limits of its own: our team agrees them with the
// organization after it asks (components/Billing/enterprise.js). Monthly or
// annual is chosen when the offer comes, with both prices in view.
function EnterprisePlanInformation() {
   return (
      <section className="plan-information-review">
         <div className="left-block">
            <h2 style={{ color: "#5770cb" }}>Plan type</h2>
            <div>
               <p>Plan’s name</p>
               <span>Enterprise</span>
            </div>
            <div>
               <p>Price</p>
               <span>Custom pricing, agreed with our team</span>
            </div>
         </div>
         <div className="right-block">
            <h2 style={{ color: "#5770cb" }}>Plan details</h2>
            <ul>
               <li>
                  <span>
                     <AiOutlineCheckCircle /> Workspaces, projects and users set to what you need
                  </span>
               </li>
               <li>
                  <span>
                     <AiOutlineCheckCircle /> Monthly, or annual on a 12-month commitment
                  </span>
               </li>
               <li>
                  <span>
                     <AiOutlineCheckCircle /> Nothing is charged until you take up your offer
                  </span>
               </li>
            </ul>
         </div>
      </section>
   );
}

// What the review step is about to be charged for. Both the plan and the period
// are read straight out of the registration on every render — they were state
// seeded once on mount, which is a copy that a reload or a change of plan
// leaves behind.
function PlanInformation() {
   const selectedPlan = getRegisteringPlan();

   const isYearly = isBilledYearly();

   if (isEnterprisePacket(selectedPlan?.id)) return <EnterprisePlanInformation />;

   return (
      <section className="plan-information-review">
         <>
            <div className="left-block">
               <h2 style={{ color: "#5770cb" }}>Plan type</h2>
               <div>
                  <p>Plan’s name</p>
                  {<span>{selectedPlan?.name}</span>}
               </div>
               <div>
                  <p>Price</p>
                  {/* Priced through planPricing, as the package cards are: this
                      sits directly above the pay button, so the annual plan's
                      terms are said here too. */}
                  <span>
                     USD {formatPrice(getPlanPrice(selectedPlan, isYearly))} / mo.
                     {isYearly ? `, ${ANNUAL_BILLING_TERMS},` : ""} plus any applicable taxes
                  </span>
               </div>
            </div>
            <div className="right-block">
               <h2 style={{ color: "#5770cb" }}>Plan details</h2>
               <ul>
                  <li>
                     <span>
                        <AiOutlineCheckCircle />{" "}
                        {selectedPlan?.workspaceLimit != 0
                           ? selectedPlan?.workspaceLimit
                           : "Unlimited"}{" "}
                        workspace
                     </span>
                  </li>
                  <li>
                     <span>
                        <AiOutlineCheckCircle />{" "}
                        {selectedPlan?.membersLimit != 0 ? selectedPlan?.membersLimit : "Unlimited"}{" "}
                        users/workspace
                     </span>
                  </li>
                  <li>
                     <span>
                        <AiOutlineCheckCircle />{" "}
                        {selectedPlan?.databaseLimit != 0 ? (
                           <>{selectedPlan?.databaseLimit} GB data storage limit</>
                        ) : (
                           <>Unlimited data storage</>
                        )}
                     </span>
                  </li>
               </ul>
            </div>
         </>
      </section>
   );
}

export { PlanInformation };
